import { sortByDate } from "../functions/sortByDate";
import useSourceFlowCollection from "../hooks/useSourceFlowCollection";
import data from "../.sourceflow/news.json";
import countryFiltersData from "../.sourceflow/news_country_filters.json";
import tagsFiltersData from "../.sourceflow/news_tag.json";

export const useBlogs = ({ limit = null, tagFilters = [], countryFilters = ["All"] } = {}) => {
  const collection = sortByDate(useSourceFlowCollection(data), "publish_date");

  // Map country filter IDs to actual names
  const allowedCountries = countryFiltersData.category_values
    .filter(country => countryFilters.includes(country.id)) // Match filter IDs
    .map(country => country.name.en);

  // Map tag filter IDs to actual names
  const allowedTags = tagsFiltersData.category_values
    .filter(tag => tagFilters.includes(tag.id)) // Match filter IDs
    .map(tag => tag.title.en);

  // Filter blogs by country and tags
  const filteredCollection = collection.filter(blog => {
    const blogCountry = blog.country || "All";
    const blogTags = Array.isArray(blog.tag) ? blog.tag : [];

    const matchesCountry = allowedCountries.includes(blogCountry);
    const matchesTags = allowedTags.length === 0 || allowedTags.every(tag => blogTags.includes(tag));

    return matchesCountry && matchesTags;
  });

  // Apply limit if provided
  return limit ? filteredCollection.slice(0, limit) : filteredCollection;
};

export default useBlogs;
